import i18n from '@/i18n';
import { admins } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const Admins = () => import('./views/Index.vue');
const AdminView = () => import('./views/AdminView.vue');

export default [
  {
    path: 'admins',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.Admins`,
        component: Admins,
        meta: { title: i18n.global.t('admins.admins'), permission: { module: admins.module, key: admins.showAll } },
      },
      {
        path: 'view/:id?',
        name: `${PREFIX.INSPECTOR}.Admins.View`,
        component: AdminView,
        meta: {
          title: i18n.global.t('admins.view'),
          pageType: 'view',
          permission: { module: admins.module, key: admins.showOne },
        },
        props: true,
      },
      {
        path: 'create',
        name: `${PREFIX.INSPECTOR}.Admins.Create`,
        component: AdminView,
        meta: {
          title: i18n.global.t('admins.create'),
          pageType: 'create',
          permission: { module: admins.module, key: admins.create },
        },
      },
      {
        path: 'update/:id?',
        name: `${PREFIX.INSPECTOR}.Admins.Update`,
        meta: {
          title: i18n.global.t('admins.update'),
          pageType: 'update',
          permission: { module: admins.module, key: admins.update },
        },
        component: AdminView,
        props: true,
      },
    ],
  },
];
